import { GridActionsColDef, GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import {
  booleanFilterOperators,
  dateFilterOperators,
  filterOperators,
  numberFilterOperators
} from './../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import DataGridCell from 'components/common/DataGridCell';
import { Chip } from '@mui/material';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { IMacroExam } from 'interfaces';

export function MedicalServiceColumns(
  groups: any,
  macroExams?: IMacroExam[],
  exam_code?: string,
  quantity?: string
): (GridColDef | GridActionsColDef)[] {
  const { t } = useTranslation();
  const translationPrefix = 'pages.medical-services.list';
  console.log(`colonne: `, macroExams?.length);
  return [
    {
      field: 'exam',
      headerName: exam_code ? exam_code : t(`${translationPrefix}.entity.exam`),
      flex: 1,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'registered',
      headerName: t(`global.registered`),
      width: 80,
      sortable: true,
      filterOperators: booleanFilterOperators,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          sx={{ background: 'transparent' }}
          icon={params.value ? <Check color="success" /> : <Close color="error" />}
        />
      )
    },
    {
      field: 'quantity',
      headerName: quantity ? quantity : t(`global.quantity`), // potrebbe dare problemi quantity string or number
      flex: 1,
      filterOperators: numberFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'request_date',
      headerName: t(`${translationPrefix}.entity.request_date`),
      flex: 1,
      filterOperators: dateFilterOperators,
      renderCell: (params: GridRenderCellParams<string>) => (
        <DataGridCell content={params.value && dayjs(params.value).format('DD/MM/YYYY')} />
      )
    },
    {
      field: 'service_date',
      headerName: t(`${translationPrefix}.entity.service_date`),
      flex: 1,
      filterOperators: dateFilterOperators,
      renderCell: (params: GridRenderCellParams<string>) => (
        <DataGridCell content={dayjs(params.value).format('DD/MM/YYYY')} />
      )
    },
    {
      field: 'req_department',
      headerName: t(`${translationPrefix}.entity.request_department`),
      flex: 1,
      filterOperators,
      editable: groups.includes('TENANT_ADMIN') || groups.includes('SUPER_ADMIN'),
      renderCell: baseCell
    },
    {
      field: 'req_laboratory',
      headerName: t(`${translationPrefix}.entity.request_laboratory`),
      flex: 1,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'exec_laboratory',
      headerName: t(`${translationPrefix}.entity.execution_laboratory`),
      flex: 1,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'workstation',
      headerName: t(`global.workstation`),
      flex: 1,
      filterOperators,
      renderCell: baseCell
    }
  ];
}
